import React from 'react'
import css from '@emotion/css'
import classNames from 'classnames'

import In from './in'
import Arrow from './arrow'
import Header from './header'
import Name, { songClass } from './name'
import {
    FS_S,
    EXPO_EASE_OUT,
    mq,
    EXPO_EASE_IN_OUT,
    POWER4_EASE_IN_OUT,
} from '../css/style'

import backgroundTop from '../images/fond-top.jpg'
import backgroundBottom from '../images/fond-bottom.png'
import cover from '../images/cover.jpg'
import mixtapeBrush from '../images/brush-mixtape.png'
import ReleveSvg from '../images/releve.inline.svg'
import maskBtn from '../images/mask-cta.png'

import montana from '../images/artistes/_0000_GREENMONTANA.jpg'
import laylow from '../images/artistes/_0001_LAYLOW.jpg'
import loveni from '../images/artistes/_0002_LOVENI.jpg'
import zed from '../images/artistes/_0003_ZED.jpg'
import lala from '../images/artistes/_0004_LALAACE.jpg'
import boleman from '../images/artistes/_0005_BOLEMAN.jpg'
import hatik from '../images/artistes/_0006_HATIK.jpg'
import didi from '../images/artistes/_0007_DIDDITRIKS.jpg'
import kikesa from '../images/artistes/_0008_KIKESA.jpg'
import varnish from '../images/artistes/_0009_VARNISH.jpg'
import zikxo from '../images/artistes/_0010_ZIKXO.jpg'
import isha from '../images/artistes/_0011_ISHA.jpg'

const Part2 = ({
    isMixtapeInViewport,
    handleMixtapeIn,
    playlistLink,
    isDesktop,
}) => {
    return (
        <div css={containerClass}>
            <section css={paragraphContainerClass}>
                <a href={playlistLink}>
                    <img src={cover} alt="" />
                </a>
                <div>
                    <p css={[songClass, discoverClass]}>
                        La
                        <br />
                        <ReleveSvg />
                    </p>
                    <h2 css={[titleClass, paraTitleClass]}>
                        Une mixtape
                        <br />
                        exclusive
                    </h2>
                    <br />
                    <a
                        href={playlistLink}
                        css={css`
                            ${buttonClass};
                        `}
                    >
                        <div className="border" />
                        <Arrow fill="white" /> Écouter
                    </a>
                </div>
            </section>
            <section css={nameContainerClass}>
                <h2 css={titleClass}>
                    La mixtape
                    <In cb={handleMixtapeIn}>
                        <div
                            className={classNames('brush', {
                                'is-in': isMixtapeInViewport,
                            })}
                        />
                    </In>
                </h2>
                <Name
                    song="001 - Artiste"
                    name="Bolemvn"
                    img={boleman}
                    decal={18}
                    decalTitle={-13}
                    isDesktop={isDesktop}
                    isRight={true}
                />
                <Name
                    song="002 - C'est nous"
                    name="Diddi Trix"
                    img={didi}
                    decal={-14}
                    decalTitle={17}
                    isDesktop={isDesktop}
                    isRight={false}
                />
                <Name
                    song="003 - Là-haut"
                    name="Kikesa"
                    img={kikesa}
                    decal={-40}
                    decalTitle={-15}
                    isDesktop={isDesktop}
                    isRight={false}
                />
                <Name
                    song="004 - BBB"
                    name="Lala &ce"
                    img={lala}
                    decal={10}
                    decalTitle={-15}
                    isDesktop={isDesktop}
                    isRight={true}
                />
                <Name
                    song="005 - Pour de vrai"
                    name="Hatik"
                    img={hatik}
                    decal={20}
                    decalTitle={8}
                    isDesktop={isDesktop}
                    isRight={true}
                />
                <Name
                    song="006 - Comme ça"
                    name="Zikxo"
                    img={zikxo}
                    decal={-10}
                    decalTitle={-20}
                    isDesktop={isDesktop}
                    isRight={false}
                />
                <Name
                    song="007 - Ça recommence"
                    img={montana}
                    decal={-37}
                    decal2={30}
                    decalTitle={-10}
                    isDesktop={isDesktop}
                    isRight={false}
                >
                    <span>Green</span>
                    <br />
                    <span>Montana</span>
                </Name>

                <Name
                    song="008 - Nana du rap game"
                    name="Isha"
                    img={isha}
                    decal={40}
                    decalTitle={0}
                    isDesktop={isDesktop}
                    isRight={true}
                />
                <Name
                    song="009 - Pro pirate"
                    img={zed}
                    decal={-23}
                    decal2={16}
                    decalTitle={-15}
                    isDesktop={isDesktop}
                    isRight={false}
                >
                    <span>Zed Yun</span>
                    <br />
                    <span>Pavarotti</span>
                </Name>
                <Name
                    song="010 - Casting"
                    name="Laylow"
                    img={laylow}
                    decal={10}
                    decalTitle={20}
                    isDesktop={isDesktop}
                    isRight={true}
                />
                <Name
                    song="011 - Todo bem"
                    name="Loveni"
                    img={loveni}
                    decal={-40}
                    decalTitle={-15}
                    isDesktop={isDesktop}
                    isRight={false}
                />
                <Name
                    song="012 - Balloon"
                    img={varnish}
                    decal={20}
                    decal2={-32}
                    decalTitle={20}
                    isDesktop={isDesktop}
                    isRight={true}
                >
                    <span>Varnish</span>
                    <br />
                    <span>la piscine</span>
                </Name>
            </section>
            <footer css={footerClass}>
                <a href={playlistLink}>
                    <img src={cover} alt="" />
                </a>
                <div>
                    <p css={songClass}>
                        <a href={playlistLink}>
                            Découvrir
                            <br />
                            la <ReleveSvg />
                        </a>
                    </p>
                    <a
                        href={playlistLink}
                        css={css`
                            ${buttonClass};

                            .border {
                                border-color: black;
                            }
                        `}
                    >
                        <div className="border" />
                        <Arrow fill="black" /> Écouter
                    </a>
                </div>
                <Header customCss={headerClass} fill="white" />
                <div css={mentionClass}>
                    <a href="https://www.deezer.com/legal/legal" target="blank">
                        Mentions légales
                    </a>
                    <a href="https://www.deezer.com">© Deezer 2019</a>
                </div>
            </footer>
        </div>
    )
}

const containerClass = css`
    background-color: white;
    left: 0;
    position: absolute;
    top: 100vh;
    width: 100%;
`

const titleClass = css`
    color: white;
    display: inline-block;
    font-family: 'Avenir';
    font-size: 50px;
    font-weight: 800;
    margin: 0 0 0.5em 1.5em;
    padding-top: 2em;
    position: relative;
    text-transform: uppercase;
    z-index: 1;

    ${mq.small(css`
        font-size: 110px;
    `)};

    .brush {
        background-image: url(${mixtapeBrush});
        background-position: -10% -4%;
        background-repeat: no-repeat;
        background-size: 100% auto;
        top: 1.9em;
        height: calc(100% - 2em);
        left: -0.5em;
        pointer-events: none;
        position: absolute;
        overflow: hidden;
        width: 120%;
        z-index: -1;

        &::after {
            background-color: white;
            content: '';
            height: 100%;
            left: 0;
            position: absolute;
            top: 0;
            transform: skew(-10deg) translateX(0%);
            transform-origin: right center;
            transition: transform 1s ${EXPO_EASE_OUT};

            width: 100%;
        }

        &.is-in::after {
            transform: translateX(101%);
        }
    }
`

const paragraphContainerClass = css`
    align-items: center;
    background-color: black;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-bottom: 8vw;

    ${mq.small(css`
        flex-direction: unset;
        padding: 4vw 0;
    `)};

    img {
        display: block;
        margin: 8vw auto;
        width: 80%;

        ${mq.small(css`
            margin: 5em 10em 5em 0;
            width: 400px;
        `)};
    }
`

const nameContainerClass = css`
    background-image: url(${backgroundTop});
    background-position: top;
    background-repeat: no-repeat;
    background-size: 100% auto;
    overflow: hidden;
    padding-bottom: 7vw;
`

const paraTitleClass = css`
    line-height: 0.85;
    margin: 0;
    padding-top: 0;
    -webkit-text-fill-color: transparent;
    -webkit-text-stroke: 1px white;
`

export const buttonClass = css`
    color: inherit;
    cursor: pointer;
    display: inline-block;
    font-size: ${FS_S};
    line-height: 1;
    margin-top: 2em;
    padding: 2em 3.5em;
    position: relative;
    transition: color 0.1s linear 0.15s;
    z-index: 1;

    @media (hover: hover) {
        &:hover {
            color: black;

            .border {
                background-position: right 100% center;
                transform: translate3d(-50%, -50%, 0) scale(1.07);
                transition: transform 0.5s ${POWER4_EASE_IN_OUT},
                    background-position 0.5s ${EXPO_EASE_IN_OUT};
            }

            .arrow {
                transform: translate(-0.15em);

                * {
                    fill: black !important;
                }
            }
        }
    }

    .border {
        background-image: url(${maskBtn});
        background-position: right -100% center;
        background-repeat: no-repeat;
        background-size: 202% 200%;
        border: 2px solid white;
        border-radius: 50px;
        height: 100%;
        left: 50%;
        position: absolute;
        top: 50%;
        transform: translate3d(-50%, -50%, 0);
        transition: transform 0.3s linear,
            background-position 0.5s ${EXPO_EASE_IN_OUT};
        width: 100%;
        will-change: transform, background-position;
        z-index: -1;
    }
`

const footerClass = css`
    align-items: center;
    background-image: url(${backgroundBottom});
    background-position: bottom;
    background-repeat: no-repeat;
    background-size: 100% auto;
    color: black;
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding-bottom: 12vh;
    padding-top: 8vh;
    position: relative;

    ${mq.small(css`
        flex-direction: unset;
        padding-bottom: 20vh;
    `)};

    button {
        margin-top: 0;
    }

    img {
        display: block;
        height: 300px;
        width: 300px;

        ${mq.small(css`
            margin-right: 60px;
        `)};
    }

    p {
        margin: 1em 0 0.25em;
        text-align: center;

        svg {
            fill: black;
            width: 3em;
        }

        ${mq.small(css`
            margin-top: 0;
            text-align: left;
        `)};
    }

    > a img {
        box-shadow: 5px 5px 20px rgba(0, 0, 0, 0.2);
    }
`

const headerClass = css`
    bottom: 60px;
    display: none;
    top: auto !important;

    ${mq.small(css`
        display: inherit;
    `)};
`

const mentionClass = css`
    bottom: 10px;
    color: white;
    font-size: ${FS_S};
    left: 0;
    position: absolute;
    right: 0;
    text-align: center;

    ${mq.small(css`
        bottom: 60px;
        left: auto;
        right: 120px;
    `)};

    a:not(:last-of-type) {
        margin-right: 1em;
    }
`

const discoverClass = css`
    color: white;
    display: block;
    font-size: 50px;
    margin: 0 !important;
    position: relative;
    top: 0.3em;

    svg {
        fill: white;
        width: 3em;
    }

    ${mq.small(css`
        font-size: 110px;
    `)};
`

export default Part2
